export default __webpack_public_path__ + "static/media/kpp-networks-loop-30s.4ac04263.mp4";